import React from "react";
import { icons, TIconsNames } from "../iconSets";
import { useGlobalStore } from "../../../store";

interface IconComponentProps {
  size?: number | string;
  color?: string;
  icon: TIconsNames;
  className?: string;
}

const Icon: React.FC<IconComponentProps> = ({
  size = "20px",
  color,
  icon,
  className = "",
}) => {
  const theme = useGlobalStore((state) => state.theme);
  const whiteVariant = `${icon}-white` as TIconsNames;
  const resolvedIcon =
    !color && theme === "dark" && icons[whiteVariant] ? whiteVariant : icon;
  const IconSrc = icons[resolvedIcon];
  if (color) {
    return (
      <div
        className={className}
        style={{
          width: size,
          height: size,
          backgroundColor: color,
          maskImage: `url(${IconSrc})`,
          WebkitMaskImage: `url(${IconSrc})`,
          maskRepeat: "no-repeat",
          WebkitMaskRepeat: "no-repeat",
          maskSize: "contain",
          WebkitMaskSize: "contain",
        }}
      />
    );
  }

  return (
    <img
      src={IconSrc}
      alt={icon}
      style={{ width: size }}
      className={className}
    />
  );
};

export default Icon;
